import { useTheme } from '@emotion/react';
import { IconButton, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import ProfileImageUploader from '../../../../components/ProfileImageUploader.js/ProfileImageUploader';
import EditIcon from '@mui/icons-material/Edit';
import CompanyInfoItem from './CompanyInfoItem';
import { useDispatch, useSelector } from 'react-redux';
import EditProfile from './EditProfile';
import appapi from '../../../../api/apiClient';
import uploadFileToS3 from '../../../../utils/fileUpload';
import { setLoading } from '../../../../redux/features/appSlice';
import { refreshUserData } from '../../../../redux/features/authSlice';
import profileDefault from '../../../../assets/images/profileDefault.svg';
import { useTranslation } from 'react-i18next';

export default function UserDetailsCard() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { userId, user } = useSelector((state) => state.auth);

  const [openEditProfile, setOpenEditProfile] = useState(false);

  const { t } = useTranslation();

  const handleFile = async (file) => {
    if (file) {
      dispatch(setLoading(true));
      try {
        const url = await uploadFileToS3(file);
        const response = await appapi.put(`user/profileImage`, {
          image: url,
        });
        if (response.ok) {
          const data = response.data;
          if (data.status === '7400') {
            dispatch(refreshUserData({ ...user, profileImage: url }));
          }
          dispatch(setLoading(false));
        } else {
          dispatch(setLoading(false));
        }
      } catch (e) {
        dispatch(setLoading(false));
      }
    }
  };

  const onClickEdit = () => {
    setOpenEditProfile(true);
  };

  return (
    <>
      <Stack style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', padding: '16px', borderColor: '#8993AC26', borderWidth: '1px' }}>
        <Typography
          className="fs-16 ff-Roboto fw-regular"
          color={text}
        >
          {t('User details')}
        </Typography>
        <Typography
          className="fs-12 ff-Roboto fw-regular"
          color={textLight}
        >
          {t('Some info may be visible to other people using ZeroEmission services')}
        </Typography>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          className="mt-[32px]"
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={textLight}
          >
            {t('Profile logo')}
          </Typography>
          <ProfileImageUploader
            url={user?.profileImage ? user?.profileImage : profileDefault}
            inputId={`doc`}
            handleFile={(files) => handleFile(files)}
            showFileName={false}
            width={'64px'}
            height={'64px'}
            iconViewHeight={'16px'}
            iconMargin={'50px'}
            iconSize={'10px'}
          />
        </Stack>
        <CompanyInfoItem
          title={t("Full name")}
          value={user?.name}
          onClickEdit={() => onClickEdit()}
        />
        <CompanyInfoItem
          title={t("Designation")}
          value={user?.designation}
          onClickEdit={() => onClickEdit()}
        />
        <CompanyInfoItem
          capitalize={false}
          showEditIcon={false}
          title={t("Email")}
          value={user?.email}
          onClickEdit={() => onClickEdit()}
        />
        <CompanyInfoItem
          title={t("Phone")}
          value={(user?.phoneCode || '') + '-' + user?.phoneNumber}
          onClickEdit={() => onClickEdit()}
        />
      </Stack>
      {openEditProfile && (
        <EditProfile
          modelOpen={openEditProfile}
          handleClose={() => setOpenEditProfile(false)}
        />
      )}
    </>
  );
}
